module.exports = __webpack_public_path__ + "img/art-9.ee70b25b.png";